import { IExternalScriptExecutable } from "../../../domain/document/items";
import { ExecuteRequest } from ".";

export class BatchRequest {
  source: IExternalScriptExecutable;
  action: string;
  request: ExecuteRequest;
}
